<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-28 10:31:17
 * @LastEditors: zailong
 * @LastEditTime: 2024-03-20 10:06:54
-->
<template>
  <div style="width: 100%; overflow: auto">
    <section class="page-title">{{ pageTitle }}</section>
    <div class="container">
      <section class="leftContent">
        <section class="header">
          <div class="title">机构入驻信息</div>
          <div class="information">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="150px"
              class="demo-ruleForm"
            >
              <el-form-item label="机构名称" prop="entName">
                <el-input v-model="ruleForm.entName" readonly></el-input>
              </el-form-item>
              <el-form-item label="详细地址" prop="address">
                <el-input
                  v-model="ruleForm.address"
                  :readOnly="readOnly"
                ></el-input>
              </el-form-item>
              <el-form-item label="企业类型" prop="entType">
                <!-- <el-input
                  v-model="ruleForm.entType"
                  :readOnly="readOnly"
                ></el-input> -->
                <el-select
                  v-model="ruleForm.entType"
                  clearable
                  placeholder="请选择企业类型"
                  :disabled="readOnly"
                >
                  <el-option
                    v-for="item in entType"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="服务分类"
                prop="serviceType"
                v-if="type == 1"
                key="serviceType"
              >
                <el-cascader
                  v-model="generalServiceTypeList"
                  @change="changeGeneralServiceType"
                  :options="generalServiceTypeOptions"
                  :props="props"
                  :disabled="readOnly"
                  clearable
                ></el-cascader>
              </el-form-item>
              <el-form-item
                label="服务分类"
                prop="serviceType"
                v-else
                key="serviceType"
              >
                <el-select
                  v-model="serviceTypeList"
                  multiple
                  clearable
                  placeholder="请选择"
                  @change="changeServiceType"
                  :disabled="readOnly"
                >
                  <el-option
                    v-for="item in serviceTypeOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="String(item.id)"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="机构简介" prop="entIntroduce">
                <el-input
                  :readOnly="readOnly"
                  v-model="ruleForm.entIntroduce"
                  type="textarea"
                  maxlength="500"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人" prop="contact">
                <el-input
                  v-model="ruleForm.contact"
                  :readOnly="readOnly"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人职务" prop="position">
                <el-input
                  v-model="ruleForm.position"
                  :readOnly="readOnly"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="contactTel">
                <el-input
                  v-model="ruleForm.contactTel"
                  :readOnly="readOnly"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="法人身份证正反面"
                prop="frCertificateUrl"
                ref="imageId"
                v-if="type == 2"
              >
                <div v-if="readOnly && frCertificateUrlList.length == 0">-</div>
                <el-upload
                  v-else
                  :class="{ hide: readOnly }"
                  :disabled="readOnly"
                  :headers="uploadHeader"
                  :action="uploadFileByContentType"
                  :before-upload="beforeAvatarUpload"
                  list-type="picture-card"
                  :limit="5"
                  :on-exceed="handleExceed"
                  :file-list="frCertificateUrlList"
                  accept=".jpg, .png, .jpeg"
                  :on-preview="
                    (file) => handlePictureCardPreview(file, 'frCertificateUrl')
                  "
                  :on-remove="
                    (file, fileList) =>
                      handleRemove(file, fileList, 'frCertificateUrl')
                  "
                  :on-success="
                    (res, file, fileList) =>
                      docSuccess(res, file, fileList, 'frCertificateUrl')
                  "
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!-- <div>建议尺寸750*240或比例25:8，小于1M的JPG、PNG格式图片</div> -->
              </el-form-item>
            </el-form>
          </div>
        </section>
        <section class="content">
          <div class="title">账号信息</div>
          <div class="information">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm1"
              label-width="150px"
              class="demo-ruleForm"
            >
              <el-form-item label="银行开户名" prop="bankName">
                <el-input
                  v-model="ruleForm.bankName"
                  :readOnly="readOnly"
                ></el-input>
              </el-form-item>
              <el-form-item label="开户银行" prop="bankType">
                <el-input
                  v-model="ruleForm.bankType"
                  :readOnly="readOnly"
                ></el-input>
              </el-form-item>
              <el-form-item label="开户银行账号" prop="bankNumber">
                <el-input
                  v-model="ruleForm.bankNumber"
                  :readOnly="readOnly"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="开户证明扫描"
                prop="bankProveUrl"
                ref="imageId"
              >
                <div v-if="readOnly && bankProveUrlList.length == 0">-</div>
                <el-upload
                  v-else
                  :class="{ hide: readOnly }"
                  :disabled="readOnly"
                  :headers="uploadHeader"
                  :action="uploadFileByContentType"
                  :before-upload="beforeAvatarUpload"
                  list-type="picture-card"
                  :limit="5"
                  :on-exceed="handleExceed"
                  accept=".jpg, .png, .jpeg"
                  :file-list="bankProveUrlList"
                  :on-preview="
                    (file) => handlePictureCardPreview(file, 'bankProveUrl')
                  "
                  :on-remove="
                    (file, fileList) =>
                      handleRemove(file, fileList, 'bankProveUrl')
                  "
                  :on-success="
                    (res, file, fileList) =>
                      docSuccess(res, file, fileList, 'bankProveUrl')
                  "
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!-- <div>建议尺寸750*240或比例25:8，小于1M的JPG、PNG格式图片</div> -->
              </el-form-item>
            </el-form>
          </div>
        </section>
        <section class="content">
          <div class="title">资质证件</div>
          <div class="information">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm2"
              label-width="270px"
              class="demo-ruleForm"
            >
              <el-form-item
                label="营业执照"
                prop="businessLicenseUrl"
                ref="imageId"
                key="businessLicenseUrl"
              >
                <div v-if="readOnly && businessLicenseUrlList.length == 0">
                  -
                </div>
                <el-upload
                  v-else
                  :class="{ hide: readOnly }"
                  :disabled="readOnly"
                  :headers="uploadHeader"
                  :action="uploadFileByContentType"
                  :before-upload="beforeAvatarUpload"
                  list-type="picture-card"
                  :limit="5"
                  :on-exceed="handleExceed"
                  accept=".jpg, .png, .jpeg"
                  :file-list="businessLicenseUrlList"
                  :on-preview="
                    (file) =>
                      handlePictureCardPreview(file, 'businessLicenseUrl')
                  "
                  :on-remove="
                    (file, fileList) =>
                      handleRemove(file, fileList, 'businessLicenseUrl')
                  "
                  :on-success="
                    (res, file, fileList) =>
                      docSuccess(res, file, fileList, 'businessLicenseUrl')
                  "
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="荣誉奖项" prop="honorUrl" ref="imageId">
                <div v-if="readOnly && honorUrlList.length == 0">-</div>
                <el-upload
                  v-else
                  :class="{ hide: readOnly }"
                  :disabled="readOnly"
                  :headers="uploadHeader"
                  :action="uploadFileByContentType"
                  :before-upload="beforeAvatarUpload"
                  list-type="picture-card"
                  :limit="5"
                  :on-exceed="handleExceed"
                  accept=".jpg, .png, .jpeg"
                  :file-list="honorUrlList"
                  :on-preview="
                    (file) => handlePictureCardPreview(file, 'honorUrl')
                  "
                  :on-remove="
                    (file, fileList) => handleRemove(file, fileList, 'honorUrl')
                  "
                  :on-success="
                    (res, file, fileList) =>
                      docSuccess(res, file, fileList, 'honorUrl')
                  "
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item
                label="服务资质证明"
                prop="qualifiedServiceUrlList"
                ref="imageId"
                v-if="type == 2"
              >
                <div v-if="readOnly && qualifiedServiceUrlList.length == 0">
                  -
                </div>
                <el-upload
                  v-else
                  :class="{ hide: readOnly }"
                  :disabled="readOnly"
                  :headers="uploadHeader"
                  :action="uploadFileByContentType"
                  :before-upload="beforeAvatarUploadAlone"
                  :limit="5"
                  multiple
                  :accept="acceptFileType"
                  :file-list="qualifiedServiceUrlList"
                  :on-exceed="handleExceed"
                  :on-preview="
                    (file) =>
                      handlePictureCardPreview(file, 'qualifiedServiceUrlList')
                  "
                  :on-remove="
                    (file, fileList) =>
                      handleRemove(file, fileList, 'qualifiedServiceUrlList')
                  "
                  :on-success="
                    (res, file, fileList) =>
                      docSuccess(res, file, fileList, 'qualifiedServiceUrlList')
                  "
                >
                  <el-button icon="el-icon-upload2">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    支持扩展名：.rar .zip .doc .docx .pdf .jpg 格式最多5个
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item
                label="上年度企业服务成效证明"
                prop="lastYearEntServerResultUrlList"
                ref="imageId"
                v-if="type == 2"
              >
                <div
                  v-if="readOnly && lastYearEntServerResultUrlList.length == 0"
                >
                  -
                </div>
                <el-upload
                  v-else
                  :class="{ hide: readOnly }"
                  :disabled="readOnly"
                  :headers="uploadHeader"
                  :action="uploadFileByContentType"
                  :before-upload="beforeAvatarUploadAlone"
                  :limit="5"
                  :accept="acceptFileType"
                  :file-list="lastYearEntServerResultUrlList"
                  :on-exceed="handleExceed"
                  :on-preview="
                    (file) =>
                      handlePictureCardPreview(
                        file,
                        'lastYearEntServerResultUrlList'
                      )
                  "
                  :on-remove="
                    (file, fileList) =>
                      handleRemove(
                        file,
                        fileList,
                        'lastYearEntServerResultUrlList'
                      )
                  "
                  :on-success="
                    (res, file, fileList) =>
                      docSuccess(
                        res,
                        file,
                        fileList,
                        'lastYearEntServerResultUrlList'
                      )
                  "
                >
                  <el-button icon="el-icon-upload2">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    支持扩展名：.rar .zip .doc .docx .pdf .jpg 格式最多5个
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item
                label="从业人员职称或从业资格证"
                prop="professionalUrlList"
                ref="imageId"
                v-if="type == 2"
              >
                <div v-if="readOnly && professionalUrlList.length == 0">-</div>
                <el-upload
                  v-else
                  :class="{ hide: readOnly }"
                  :disabled="readOnly"
                  :headers="uploadHeader"
                  :action="uploadFileByContentType"
                  :before-upload="beforeAvatarUploadAlone"
                  :on-exceed="handleExceed"
                  :limit="5"
                  :accept="acceptFileType"
                  :file-list="professionalUrlList"
                  :on-preview="
                    (file) =>
                      handlePictureCardPreview(file, 'professionalUrlList')
                  "
                  :on-remove="
                    (file, fileList) =>
                      handleRemove(file, fileList, 'professionalUrlList')
                  "
                  :on-success="
                    (res, file, fileList) =>
                      docSuccess(res, file, fileList, 'professionalUrlList')
                  "
                >
                  <el-button icon="el-icon-upload2">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    支持扩展名：.rar .zip .doc .docx .pdf .jpg 格式最多5个
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item
                label="上年度纳税证明"
                prop="lastYearEntTaxUrlList"
                ref="imageId"
                v-if="type == 2"
              >
                <div v-if="readOnly && lastYearEntTaxUrlList.length == 0">
                  -
                </div>
                <el-upload
                  v-else
                  :class="{ hide: readOnly }"
                  :disabled="readOnly"
                  :headers="uploadHeader"
                  :action="uploadFileByContentType"
                  :before-upload="beforeAvatarUploadAlone"
                  :on-exceed="handleExceed"
                  :limit="5"
                  :accept="acceptFileType"
                  :file-list="lastYearEntTaxUrlList"
                  :on-preview="
                    (file) =>
                      handlePictureCardPreview(file, 'lastYearEntTaxUrlList')
                  "
                  :on-remove="
                    (file, fileList) =>
                      handleRemove(file, fileList, 'lastYearEntTaxUrlList')
                  "
                  :on-success="
                    (res, file, fileList) =>
                      docSuccess(res, file, fileList, 'lastYearEntTaxUrlList')
                  "
                >
                  <el-button icon="el-icon-upload2">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    支持扩展名：.rar .zip .doc .docx .pdf .jpg 格式最多5个
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item
                label="社会保险参保证明"
                prop="socialInsuranceUrlList"
                ref="imageId"
                v-if="type == 2"
              >
                <div v-if="readOnly && socialInsuranceUrlList.length == 0">
                  -
                </div>
                <el-upload
                  v-else
                  :class="{ hide: readOnly }"
                  :disabled="readOnly"
                  :headers="uploadHeader"
                  :action="uploadFileByContentType"
                  :before-upload="beforeAvatarUploadAlone"
                  :on-exceed="handleExceed"
                  :limit="5"
                  :accept="acceptFileType"
                  :file-list="socialInsuranceUrlList"
                  :on-preview="
                    (file) =>
                      handlePictureCardPreview(file, 'socialInsuranceUrlList')
                  "
                  :on-remove="
                    (file, fileList) =>
                      handleRemove(file, fileList, 'socialInsuranceUrlList')
                  "
                  :on-success="
                    (res, file, fileList) =>
                      docSuccess(res, file, fileList, 'socialInsuranceUrlList')
                  "
                >
                  <el-button icon="el-icon-upload2">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    支持扩展名：.rar .zip .doc .docx .pdf .jpg 格式最多5个
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item
                label="上年度营业收入（利润表）"
                prop="lastYearOperatingIncomeUrlList"
                ref="imageId"
                v-if="type == 2"
              >
                <div
                  v-if="readOnly && lastYearOperatingIncomeUrlList.length == 0"
                >
                  -
                </div>
                <el-upload
                  v-else
                  :class="{ hide: readOnly }"
                  :disabled="readOnly"
                  :headers="uploadHeader"
                  :action="uploadFileByContentType"
                  :before-upload="beforeAvatarUploadAlone"
                  :on-exceed="handleExceed"
                  :limit="5"
                  :accept="acceptFileType"
                  :file-list="lastYearOperatingIncomeUrlList"
                  :on-preview="
                    (file) =>
                      handlePictureCardPreview(
                        file,
                        'lastYearOperatingIncomeUrlList'
                      )
                  "
                  :on-remove="
                    (file, fileList) =>
                      handleRemove(
                        file,
                        fileList,
                        'lastYearOperatingIncomeUrlList'
                      )
                  "
                  :on-success="
                    (res, file, fileList) =>
                      docSuccess(
                        res,
                        file,
                        fileList,
                        'lastYearOperatingIncomeUrlList'
                      )
                  "
                >
                  <el-button icon="el-icon-upload2">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    支持扩展名：.rar .zip .doc .docx .pdf .jpg 格式最多5个
                    <div>
                      <Debounce :time="5000" :isDebounce="3">
                        <button
                          type="button"
                          class="el-button el-button--text"
                          @click="downTemplate(4)"
                        >
                          <span>点击下载上年度营业收入（利润表）模版</span>
                        </button>
                      </Debounce>
                    </div>
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item
                label="入驻承诺书"
                prop="institutionsLetterUrlList"
                v-if="type == 1"
              >
                <div
                  v-if="readOnly && institutionsLetterUrlListList.length == 0"
                >
                  -
                </div>
                <el-upload
                  v-else
                  :class="{ hide: readOnly }"
                  :disabled="readOnly"
                  :headers="uploadHeader"
                  :action="uploadFileByContentType"
                  :before-upload="beforeAvatarUploadPromise"
                  multiple
                  accept=".jpg,.png,.xls,.xlsx,.doc,.docx,.pdf"
                  :limit="5"
                  :on-exceed="handleExceed"
                  :file-list="institutionsLetterUrlListList"
                  :on-preview="
                    (file) =>
                      handlePictureCardPreview(
                        file,
                        'institutionsLetterUrlList'
                      )
                  "
                  :on-remove="
                    (file, fileList) =>
                      handleRemove(file, fileList, 'institutionsLetterUrlList')
                  "
                  :on-success="
                    (res, file, fileList) =>
                      docSuccess(
                        res,
                        file,
                        fileList,
                        'institutionsLetterUrlList'
                      )
                  "
                >
                  <el-button icon="el-icon-upload2">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    支持扩展名：.jpg .png .xls .xlsx .doc .docx .pdf 格式
                    <div>
                      <Debounce :time="5000" :isDebounce="3">
                        <button
                          type="button"
                          class="el-button el-button--text"
                          @click="downTemplate(3)"
                        >
                          <span>点击下载服务机构入驻承诺书模板</span>
                        </button>
                      </Debounce>
                    </div>
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item
                label="入驻承诺书"
                prop="institutionsServerLetterUrlList"
                v-if="type == 2"
              >
                <div
                  v-if="
                    readOnly && institutionsServerLetterUrlListList.length == 0
                  "
                >
                  -
                </div>
                <el-upload
                  v-else
                  :class="{ hide: readOnly }"
                  :disabled="readOnly"
                  :headers="uploadHeader"
                  :action="uploadFileByContentType"
                  :before-upload="beforeAvatarUploadPromise"
                  multiple
                  :on-exceed="handleExceed"
                  accept=".jpg,.png,.xls,.xlsx,.doc,.docx,.pdf"
                  :limit="5"
                  :file-list="institutionsServerLetterUrlListList"
                  :on-preview="
                    (file) =>
                      handlePictureCardPreview(
                        file,
                        'institutionsServerLetterUrlList'
                      )
                  "
                  :on-remove="
                    (file, fileList) =>
                      handleRemove(
                        file,
                        fileList,
                        'institutionsServerLetterUrlList'
                      )
                  "
                  :on-success="
                    (res, file, fileList) =>
                      docSuccess(
                        res,
                        file,
                        fileList,
                        'institutionsServerLetterUrlList'
                      )
                  "
                >
                  <el-button icon="el-icon-upload2">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    支持扩展名：.jpg .png .xls .xlsx .doc .docx .pdf 格式
                    <div>
                      <Debounce :time="5000" :isDebounce="3">
                        <button
                          type="button"
                          class="el-button el-button--text"
                          @click="downTemplate(3)"
                        >
                          <span>点击下载服务机构入驻承诺书模板</span>
                        </button>
                      </Debounce>
                    </div>
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="checked" :disabled="readOnly"
                  >我司承诺上述表格中所填写的内容真实有效</el-checkbox
                >
              </el-form-item>
            </el-form>
          </div>
        </section>
        <section class="review" v-show="actionType != 'view'">
          <div class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <Debounce :time="3000" :isDebounce="3">
              <button
                type="button"
                class="el-button el-button--primary el-button--medium"
                @click="sendMovenSMS()"
              >
                <span>确 定</span>
              </button>
            </Debounce>
          </div>
        </section>
      </section>
      <section class="rightContent">
        <div class="title">审核记录</div>
        <div v-if="process.length == 0" class="empty-box">暂无数据</div>
        <el-timeline v-else>
          <el-timeline-item
            :timestamp="
              item.reviewType == 3
                ? '审核通过'
                : item.reviewType == 2
                ? '审核驳回'
                : item.reviewType === 4
                ? '审核退回'
                : '提交信息'
            "
            placement="top"
            v-for="(item, index) in process"
            :key="index"
          >
            <el-card>
              <p v-if="item.reviewType != '1'">
                备注：{{ item.remark || '-' }}
              </p>
              <p v-if="getCurrentStatus(item)">操作人：{{ item.opertator }}</p>
              <p>操作时间：{{ item.operateTime }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </section>
      <!-- <el-dialog :visible.sync="dialogVisible" width="30%" class="showImg">
        <img width="100%" :src="exhibitImg" alt="" />
      </el-dialog> -->
      <el-image-viewer
        v-if="dialogVisible"
        :on-close="
          () => {
            dialogVisible = false
          }
        "
        :url-list="[exhibitImg]"
      />
    </div>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { getToken } from '@utils'
import {
  listRecords,
  checkStatus,
  submitAuthen,
  submitServerAuthen,
  govEntIntermediaryDetail,
  govEntIntermediaryDetail2,
  govEntIntermediaryDetail3,
  downEntWhiteModel,
  serviceTypeDic
} from '@api/yardIntermediary/applicationResidency'
import { uploadFileByContentType } from '@api/activityCenter/activityCenter'
import { listMyForm } from '../../../../common/api/lishui'
export default {
  components: {
    ElImageViewer
  },
  name: 'Live',
  data() {
    let checkPhone = (rule, value, callback) => {
      let reg = /^1[345789]\d{9}$/
      if (!reg.test(value)) {
        callback(new Error('请输入正确格式的手机号'))
      } else {
        callback()
      }
    }
    let checkInstitutions = (rule, value, callback) => {
      if (value.length <= 0) {
        callback(new Error('请上传入驻承诺书'))
      } else {
        callback()
      }
    }
    return {
      disabled: false,
      fit: 'fill',
      type: 1, // 1普通 2服务
      pageTitle: '',
      dialogVisible: false,
      uploadFileByContentType,
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      },
      title: '',
      ruleForm: {
        entName: '',
        creditCode: '',
        address: '',
        serviceType: '',
        generalServiceType: '',
        entType: '',
        entIntroduce: '',
        contact: '',
        position: '',
        contactTel: '',
        frCertificateUrl: '',
        bankName: '',
        bankType: '',
        bankNumber: '',
        bankProveUrl: '',
        businessLicenseUrl: '',
        qualifiedServiceUrlList: [],
        lastYearEntServerResultUrlList: [],
        professionalUrlList: [],
        institutionsLetterUrlList: [],
        lastYearEntTaxUrlList: [],
        socialInsuranceUrlList: [],
        lastYearOperatingIncomeUrlList: [],
        institutionsServerLetterUrlList: [],
        honorUrl: '',
        organizationType: '' // 申请类型 1 普通 2 服务
      },
      checked: false, // 勾选承诺
      fileList: [],
      rules: {
        entName: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        serviceType: [
          { required: true, message: '请选择服务分类', trigger: 'change' }
        ],
        /* generalServiceType: [
          { required: true, message: '请选择服务分类', trigger: 'change' }
        ], */
        entType: [
          { required: true, message: '请选择企业类型', trigger: 'change' }
        ],
        // entIntroduce: [
        //   { required: true, message: '请输入机构简介', trigger: 'blur' }
        // ],
        contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        position: [
          { required: true, message: '请输入联系人职务', trigger: 'blur' }
        ],
        contactTel: [
          { required: true, validator: checkPhone, trigger: 'blur' }
        ],
        frCertificateUrl: [
          {
            required: true,
            message: '请上传法人身份证正反面',
            trigger: 'change'
          }
        ],
        businessLicenseUrl: [
          { required: true, message: '请上传营业执照', trigger: 'change' }
        ],
        lastYearEntServerResultUrlList: [
          {
            required: true,
            message: '请上传上年度企业服务成效证明',
            trigger: 'change'
          }
        ],
        lastYearEntTaxUrlList: [
          {
            required: true,
            message: '请上传上年度纳税证明',
            trigger: 'change'
          }
        ],
        socialInsuranceUrlList: [
          {
            required: true,
            message: '请上传社会保险参保证明',
            trigger: 'change'
          }
        ],
        lastYearOperatingIncomeUrlList: [
          {
            required: true,
            message: '请上传上年度营业收入（利润表）',
            trigger: 'change'
          }
        ],
        institutionsLetterUrlList: [
          { required: true, validator: checkInstitutions, trigger: 'change' }
        ],
        institutionsServerLetterUrlList: [
          { required: true, validator: checkInstitutions, trigger: 'change' }
        ]
      },
      acceptFileType: '.rar, .zip, .doc, .docx, .pdf, .jpg, .png',
      bankProveUrlList: [], // 开户行证明
      frCertificateUrlList: [], // 法人身份证
      businessLicenseUrlList: [], // 营业执照
      honorUrlList: [], // 荣誉奖项
      qualifiedServiceUrlList: [],
      lastYearEntServerResultUrlList: [],
      professionalUrlList: [], // 从业人员职称或从业资格证
      institutionsLetterUrlListList: [], // 普通机构入驻承诺书
      institutionsServerLetterUrlListList: [], // 服务机构入驻承诺书
      lastYearEntTaxUrlList: [],
      socialInsuranceUrlList: [],
      lastYearOperatingIncomeUrlList: [],
      process: [],
      user: {},
      status: '',
      showImg: false,
      exhibitImg: '',
      serviceTypeList: [],
      serviceTypeOptions: [],
      generalServiceTypeList: [],
      generalServiceTypeOptions: [],
      creditCode: '',
      readOnly: false,
      props: { multiple: true, value: 'id', label: 'name', children: 'child' },
      options: [
        {
          value: 1,
          label: '东南',
          children: [
            {
              value: 2,
              label: '上海'
            },
            {
              value: 7,
              label: '江苏'
            },
            {
              value: 12,
              label: '浙江'
            }
          ]
        },
        {
          value: 17,
          label: '西北',
          children: [
            {
              value: 18,
              label: '陕西'
            },
            {
              value: 21,
              label: '新疆维吾尔族自治区'
            }
          ]
        }
      ],
      entType: [
        '有限责任公司',
        '股份有限公司',
        '个人独资企业',
        '合伙企业',
        '全民所有制企业',
        '集体所有制企业',
        '农民专业合作社',
        '其他'
      ],
      isUpload: true,
      rulesList: [
        'institutionsLetterUrlList',
        'institutionsServerLetterUrlList',
        'qualifiedServiceUrlList',
        'professionalUrlList',
        'lastYearEntServerResultUrlList',
        'lastYearEntTaxUrlList',
        'socialInsuranceUrlList',
        'lastYearOperatingIncomeUrlList'
      ]
    }
  },
  watch: {},
  async created() {
    this.type = this.$route.query.type
    this.creditCode = this.$route.query.creditCode
    this.ruleForm.creditCode = this.$route.query.creditCode
    this.actionType = this.$route.query.actionType
    this.readOnly = this.actionType == 'view'
    this.checked = this.actionType == 'view'
    const applytype = this.type == '1' ? '普通' : '服务券'
    this.pageTitle = applytype + '机构入驻申请'
    // 获取服务分类
    await this.getServiceTypeDic()
    // 获取审核记录
    this.listRecords()
    // 如果是新增申请
    if (this.actionType === 'add') {
      this.getBaseInfo()
    } else {
      this.govEntIntermediaryDetail()
    }
  },
  mounted() { },
  methods: {
    // 驳回和通过时，企业和机构不展示操作人项
    getCurrentStatus(data) {
      const roleText = this.$store.state.user.userInfo.roleText
      if (data.reviewType == 2 || data.reviewType == 3 || data.reviewType == 4) {
        return !(roleText === '机构' || roleText === '服务机构' || roleText == '企业')
      } else return true
    },
    handleExceed() {
      this.$message.warning('当前限制选择 5 个文件，已上传了5个文件')
    },
    // 入驻申请模板下载  1 普通 3 服务
    downTemplate(num) {
      let params = {
        moduleType: num
      }
      downEntWhiteModel(params).then((res) => {
        const result = res.data
        if (result.code === '0000') {
          window.open(result.data, '_blank')
        }
      })
    },
    getBaseInfo() {
      const params = {
        creditCode: this.$route.query.creditCode
      }
      let api = govEntIntermediaryDetail
      api(params).then((res) => {
        if (res.data.code === '0000') {
          const data = res.data.data || {}
          this.ruleForm.entName = data.entName || ''
          this.ruleForm.address = data.address || ''
          this.ruleForm.entType = data.entType || ''
          this.ruleForm.contact = data.contact || ''
          this.ruleForm.position = data.position || ''
          this.ruleForm.contactTel = data.contactTel || ''
          this.ruleForm.businessLicenseUrl = data.businessLicenseUrl || ''
          this.ruleForm.bankName = data.bankName || ''
          this.ruleForm.bankNumber = data.bankNumber || ''
          this.ruleForm.bankType = data.bankType || ''
          this.ruleForm.bankProveUrl = data.bankProveUrl || ''
          this.bankProveUrlList = this.formateList1(this.ruleForm.bankProveUrl)
          this.businessLicenseUrlList = this.formateList1(
            this.ruleForm.businessLicenseUrl
          )
        }
      })
      // checkStatus().then((res) => {
      //   if (res.data.code == '0000') {
      //     const data = res.data.data[0] || {}
      //     this.ruleForm.entName = data.entName || ''
      //     this.ruleForm.address = data.address || ''
      //     this.ruleForm.entType = data.entType || ''
      //     this.ruleForm.creditCode = this.$route.query.creditCode
      //   }
      // })
    },
    // 上传成功后
    docSuccess(res, file, fileList, key) {
      let list = []
      fileList.forEach((item) => {
        if (item.response) {
          let data = item.response.data
          if (!data.ossUrl) return

          list.push(data.ossUrl)
        } else {
          list.push(item.url)
        }
      })
      if (this.rulesList.indexOf(key) === -1) {
        this.ruleForm[key] = list.join(',')
      } else {
        this.ruleForm[key].push(file.response.data)
      }
      if (this.rulesList.indexOf(key) === -1) {
        this.$refs['ruleForm'].validateField(key)
        this.$refs['ruleForm1'].validateField(key)
        this.$refs['ruleForm2'].validateField(key)
      }
      this.isUpload = true
    },
    beforeAvatarUpload(file) {
      this.isUpload = false
      const isLt2M = file.size / 1024 / 1024 < 5
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJPG) {
        this.$message.error('上传图片只能是 .jpg, .png, .jpeg 格式!')
        this.isUpload = true
      }
      if (!isLt2M && (file.type.indexOf('png') || file.type.indexOf('jpg'))) {
        this.$message.error('上传图片大小不能超过 5MB!')
        this.isUpload = true
      }
      return isLt2M && isJPG
    },
    // 入住承诺书
    beforeAvatarUploadPromise(file) {
      this.isUpload = false
      const allowFileTypes = ['jpg', 'png', 'xls', 'xlsx', 'doc', 'docx', 'pdf']
      const fileName = file.name.split('.')
      let fileType = fileName[fileName.length - 1]
      const isFile = allowFileTypes.includes(fileType.toLowerCase())
      if (!isFile) {
        this.$message.error(
          '上传文件只能是 jpg、png、xls、xlsx、doc、docx、pdf 格式!'
        )
      }
      const isLt2M = file.size / 1024 / 1024 < 50
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 50MB!')
        this.isUpload = true
      }
      return isLt2M && isFile
    },
    beforeAvatarUploadAlone(file) {
      this.isUpload = false
      const allowFileTypes = ['rar', 'zip', 'doc', 'docx', 'pdf', 'jpg', 'png']
      const fileName = file.name.split('.')
      let fileType = fileName[fileName.length - 1]
      const isFile = allowFileTypes.includes(fileType.toLowerCase())
      if (!isFile) {
        this.$message.error(
          '上传文件只能是 rar、zip、doc、docx、pdf、jpg 格式!'
        )
      }
      const isLt2M = file.size / 1024 / 1024 < 50
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 50MB!')
        this.isUpload = true
      }
      return isLt2M && isFile
    },
    handleRemove(file, fileList, key) {
      let list = []
      let theUrl = file.url
        ? file.url
        : file.response && file.response.data.ossUrl
      fileList.forEach((item) => {
        if (item.response) {
          let data = item.response.data
          if (!data.ossUrl) return
          list.push(data.ossUrl)
        } else {
          list.push(item.url)
        }
      })
      if (this.rulesList.indexOf(key) === -1) {
        this.ruleForm[key] = list.join(',')
      } else {
        this.ruleForm[key] = this.ruleForm[key].filter(
          (item) => item.ossUrl !== theUrl
        )
      }
      if (this.rulesList.indexOf(key) === -1) {
        this.$refs['ruleForm'].validateField(key)
        this.$refs['ruleForm1'].validateField(key)
        this.$refs['ruleForm2'].validateField(key)
      }
    },
    sendMovenSMS() {
      if (this.disabled) return
      Promise.all(this.validateList()).then(() => {
        if (
          (this.ruleForm.institutionsServerLetterUrlList &&
            this.ruleForm.institutionsServerLetterUrlList.length > 0 &&
            this.type == 2 &&
            this.isUpload) ||
          (this.ruleForm.institutionsLetterUrlList &&
            this.ruleForm.institutionsLetterUrlList.length > 0 &&
            this.type == 1 &&
            this.isUpload)
        ) {
          if (this.checked) {
            this.disabled = true
            checkStatus({ organizationType: this.type }).then((res) => {
              if (res.data.code == '0000') {
                const data = res.data.data[0] || {}
                if (data.organizationType === this.type && data.status === 3) {
                  this.$message({
                    message: '该机构已审核通过不可再修改',
                    type: 'warning'
                  })
                  this.handleClose()
                } else {
                  // 做处理
                  let data = {
                    ...this.ruleForm,
                    organizationType: this.type
                    /* generalServiceType:
                      this.type == 1 ? this.ruleForm.generalServiceType : null */
                  }
                  let api = this.type == '1' ? submitAuthen : submitServerAuthen
                  api(data).then((res) => {
                    if (res.data.code == '0000') {
                      this.$message({
                        message: '机构入驻申请提交成功',
                        type: 'success'
                      })
                      this.handleClose()
                    } else {
                      this.$message({
                        message: res.data.msg,
                        type: 'error'
                      })
                    }
                  })
                }
              }
            })
          } else {
            this.$message({
              message: '请勾选承诺提交信息的真实性',
              type: 'warning'
            })
            this.disabled = false
          }
        } else {
          this.$message({
            message: '文件上传中',
            type: 'warning'
          })
          this.disabled = false
        }
      })
    },
    validateList() {
      const p1 = new Promise((resolve, reject) => {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) resolve()
        })
      })
      const p2 = new Promise((resolve, reject) => {
        this.$refs['ruleForm1'].validate((valid) => {
          if (valid) resolve()
        })
      })
      const p3 = new Promise((resolve, reject) => {
        this.$refs['ruleForm2'].validate((valid) => {
          if (valid) resolve()
        })
      })
      console.log([p1, p2, p3])
      return [p1, p2, p3]
    },
    handlePictureCardPreview(file, key) {
      console.log(file)
      if (file.name) {
        if (['jpg', 'png'].includes(file.name.split('.')[1])) {
          this.exhibitImg = file.url || file.response.data.ossUrl
          this.dialogVisible = true
        } else {
          window.open(file.url || file.response.data.ossUrl, '_blank')
        }
      } else {
        if (this.rulesList.indexOf(key) === -1) {
          this.exhibitImg = file.url
          this.dialogVisible = true
        } else {
          window.open(file.url, '_blank')
        }
      }

      // 图片预览
    },
    handleClose() {
      this.$router.push({ name: 'admission' })
    },
    // 选择服务分类
    changeServiceType() {
      this.ruleForm.serviceType = this.serviceTypeList.join(',')
    },
    // changeGeneralServiceType 普通服务分类 generalServiceType
    changeGeneralServiceType() {
      const list = []
      this.generalServiceTypeList.forEach((item) => {
        list.push(item[1])
      })
      this.ruleForm.serviceType = list.join(',')
    },
    // 根据二级id封装二维数组
    dealData(list) {
      if (!list.length) return // 如果没有长度返回
      let newList = []
      list.forEach((item) => {
        this.generalServiceTypeOptions.forEach((el) => {
          const firstId = el.id
          el.child.forEach((son) => {
            if (son.id == item) {
              newList.push([+firstId, +item])
            }
          })
        })
      })
      return newList
    },
    // 获取审核记录
    listRecords() {
      const params = {
        creditCode: this.creditCode,
        organizationType: this.type
      }
      listRecords(params).then((res) => {
        if (res.data.code === '0000') {
          this.process = res.data.data || []
        }
      })
    },
    // 查看 修改复显
    govEntIntermediaryDetail() {
      const params = {
        creditCode: this.creditCode
      }
      let api =
        this.type == 1 ? govEntIntermediaryDetail2 : govEntIntermediaryDetail3
      api(params).then((res) => {
        if (res.data.code === '0000') {
          this.ruleForm = res.data.data || {}
          console.log(this.ruleForm)
          this.ruleForm.institutionsLetterUrlList =
            this.ruleForm.institutionsLetterUrlList || []
          this.ruleForm.institutionsServerLetterUrlListList =
            this.ruleForm.institutionsServerLetterUrlListList || []
          this.serviceTypeList = this.ruleForm.serviceType
            ? this.ruleForm.serviceType.split(',')
            : []
          this.generalServiceTypeList = this.dealData(
            this.ruleForm.serviceType
              ? this.ruleForm.serviceType.split(',')
              : []
          )
          this.bankProveUrlList = this.formateList1(this.ruleForm.bankProveUrl)
          this.frCertificateUrlList = this.formateList1(
            this.ruleForm.frCertificateUrl
          )
          this.businessLicenseUrlList = this.formateList1(
            this.ruleForm.businessLicenseUrl
          )
          this.honorUrlList = this.formateList1(this.ruleForm.honorUrl)
          this.qualifiedServiceUrlList = this.formateList(
            this.ruleForm.qualifiedServiceUrlList
          )

          this.lastYearEntServerResultUrlList = this.formateList(
            this.ruleForm.lastYearEntServerResultUrlList
          )
          this.lastYearEntTaxUrlList = this.formateList(
            this.ruleForm.lastYearEntTaxUrlList
          )
          this.socialInsuranceUrlList = this.formateList(
            this.ruleForm.socialInsuranceUrlList
          )
          this.lastYearOperatingIncomeUrlList = this.formateList(
            this.ruleForm.lastYearOperatingIncomeUrlList
          )
          this.professionalUrlList = this.formateList(
            this.ruleForm.professionalUrlList
          )

          this.institutionsLetterUrlListList = this.formateList(
            this.ruleForm.institutionsLetterUrlList
          )
          this.institutionsServerLetterUrlListList = this.formateList(
            this.ruleForm.institutionsServerLetterUrlList
          )
        }
      })
    },
    formateList1(arr) {
      if (arr === '' || arr === null) {
        return []
      } else {
        let list = []
        arr.split(',').forEach((item) => {
          let obj = {
            url: item
          }
          list.push(obj)
        })
        return list
      }
    },
    formateList(arr) {
      if (arr && arr.length !== 0) {
        let list = []
        arr.forEach((item) => {
          let obj = {
            name: item.fileName,
            url: item.ossUrl
          }
          list.push(obj)
        })
        return list
      } else {
        return []
      }
    },
    // 获取服务分类
    getServiceTypeDic() {
      return new Promise((resolve) => {
        serviceTypeDic().then((res) => {
          if (res.data.code === '0000') {
            this.serviceTypeOptions = res.data.data.serviceTypeList || []
            this.generalServiceTypeOptions =
              res.data.data.generalServiceTypeList || []
            resolve()
          }
        })
      })
    }
  }
}
</script>
<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
.hide .el-upload--picture-card {
  display: none;
}
.hide .el-upload--text {
  display: none;
}
.hide .el-upload__tip {
  display: none;
}
</style>
<style lang="scss" scoped>
.page-title {
  line-height: 30px;
  font-size: 18px;
  background-color: white;
  padding: 16px 20px;
  margin: 5px 0;
}
/deep/.el-select,
/deep/.el-cascader {
  width: 100%;
}
.showImg {
  /deep/ .el-dialog__header {
    border-bottom: none !important;
  }
}
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }
  .el-dialog__body {
    // height: 400px;
    overflow: auto;
    padding: 30px 60px 20px;
    font-size: 16px;
    .el-textarea__inner {
      height: 100px;
    }
  }
  .el-upload--picture-card {
    width: 120px;
    height: 120px;
  }
  .el-upload-list__item {
    width: 120px;
    height: 120px;
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
}
.container {
  width: 100%;
  overflow: auto;
  display: flex;
  justify-content: space-between;
  & > .leftContent {
    width: calc(100% - 400px);
    > .header {
      background: white;
      > .title {
        padding: 16px 21px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      }
      & > .service {
        > div {
          width: 100%;
          display: flex;
          > div {
            > div {
              margin-bottom: 10px;
              > span {
                margin-right: 10px;
              }
            }
          }
        }
      }
      & > .information {
        padding: 0 24px 16px 24px;
        margin-top: 16px;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        > div {
          width: 450px;
          span {
            color: rgba(0, 0, 0, 0.5);
          }
        }
      }
    }
    > .content {
      margin-top: 16px;
      background: white;
      > .title {
        padding: 16px 21px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      }
      & > .information {
        padding: 0 24px 16px 24px;
        margin-top: 16px;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        img {
          cursor: pointer;
          width: 200px;
          margin-right: 15px;
        }
        > div {
          width: 400px;
          span {
            color: rgba(0, 0, 0, 0.5);
          }
        }
      }
      > .text {
        padding: 0 21px;
        font-size: 14px;
        line-height: 25px;
        color: rgba(0, 0, 0, 0.5);
        > p {
          color: rgba(0, 0, 0, 0.85);
        }
      }
      > .ImgContent {
        padding: 0 21px 30px;
        display: flex;
        margin-top: 30px;
        > div {
          width: 167px;
          height: 200px;
          line-height: 200px;
          margin-right: 20px;
          > img {
            max-height: 200px;
            vertical-align: middle;
            width: inherit;
            cursor: pointer;
            border-radius: 3px;
          }
        }
      }
    }
    > .footer {
      margin-top: 16px;
      background: white;
      > .title {
        padding: 16px 21px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      }
      > .block {
        width: 60%;
        margin-top: 30px;
      }
    }
    > .review {
      margin-top: 16px;
      padding: 24px 300px;
      background: white;
      /deep/ .el-textarea__inner {
        min-height: 150px !important;
      }
      .dialog-footer {
        display: flex;
        justify-content: center;
      }
    }
  }
  & > .rightContent {
    margin-left: 20px;
    width: 400px;
    background: white;
    height: 600px;
    .empty-box {
      font-size: 14px;
      text-align: center;
      line-height: 300px;
    }
    > .title {
      padding: 15px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    > .text {
      color: rgba(102, 102, 102, 100);
      font-size: 14px;
    }
    /deep/ .el-card {
      border: none;
      box-shadow: none;
      // background-color: rgba(0, 0, 0, 0.02);
    }
    /deep/ .el-card__body {
      padding: 0;
    }
    /deep/ .el-timeline {
      padding: 0 15px;
      background: white;
      height: 500px;
      overflow-y: scroll;
    }
    /deep/ .el-timeline-item__node {
      background-color: rgba(24, 144, 255, 1);
    }
    /deep/ .el-timeline-item__tail {
      height: 88%;
      margin-top: 15px;
      border-left: 2px solid rgba(24, 144, 255, 1);
    }
  }
}
</style>
